import React from 'react';
import { IconContainer } from './IconContainer';

const RemoveIcon = (props) => {
    return (
        <IconContainer ariaLabel="remove" cursor="pointer" { ...props }>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
                <path d="M17 6h5v2h-2v13a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V8H2V6h5V3a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v3zm1 2H6v12h12V8zm-9 3h2v6H9v-6zm4 0h2v6h-2v-6zM9 4v2h6V4H9z" fill="currentColor"/>
            </svg>
        </IconContainer>
    )
}

export { RemoveIcon };